import { Avatar } from "antd";
import { IUserInfo } from "../../models/Users";

interface MyAvatarProps {
  name: string;
  className?: string;
  userInfo?: IUserInfo;
}

const MyAvatar = ({ name, className, userInfo }: MyAvatarProps) => {
  const firstChar = name?.charAt(0).toUpperCase() || "?";
  const colors = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae"];
  const color = colors[name.charCodeAt(0) % colors.length];
  return (
    <>
      {userInfo?.avatar ? (
        <Avatar
          size="large"
          style={{
            borderColor: "#d9d9d9",
          }}
          src={userInfo?.avatar ? `${userInfo.avatar}` : undefined}
        />
      ) : (
        <Avatar
          size="large"
          style={{ backgroundColor: color, border: color }}
          className={className}
        >
          {firstChar}
        </Avatar>
      )}
    </>
  );
};

export default MyAvatar;
